import { FC } from 'react';
import Hero from 'src/about/components/Hero';
import TeamValuesGrid from 'src/about/components/TeamValuesGrid';
import PitchPageBrowseBoats from 'src/common/components/PitchPageBrowseBoats';

const AboutPageRoot: FC = () => (
  <main>
    <Hero />
    <TeamValuesGrid />
    <PitchPageBrowseBoats />
  </main>
);

export default AboutPageRoot;
